import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Stack from '@mui/material/Stack';
import { Seo } from 'src/components/seo';
import { Card, CardHeader, Skeleton, Typography } from '@mui/material';
import { EditFacilityStayForm } from './edit-facility-stay-form';
import { RouterLink } from 'src/components/router-link';
import Link from '@mui/material/Link';
import SvgIcon from '@mui/material/SvgIcon';
import ArrowLeftIcon from '@untitled-ui/icons-react/build/esm/ArrowLeft';
import { paths } from 'src/paths';
import Avatar from '@mui/material/Avatar';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { getSinglePatient } from 'src/redux/actions/patientAction';

function EditFacilityStayPage() {
  const { patients, patientDetails, editFacilityStay } = paths;
  const patientData = useSelector((state: any) => state?.getSinglePatientReducer?.patient);
  const patientResponse = useSelector((state: any) => state.getSinglePatientReducer);
  const location = useLocation();
  const [patientError, setPatientError] = useState('');
  const getPatientId = useSelector((state: any) => state?.getPatientIdReducer);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(
      getSinglePatient({
        patientId: getPatientId,
      })
    );
  }, [getPatientId]);

  useEffect(() => {
    setPatientError('');
  }, []);

  return (
    <>
      <Seo title="Facility Stay: Edit" />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: 8,
        }}
      >
        <Container maxWidth="xl">
          <Stack spacing={4}>
            <Stack spacing={4}>
              <div>
                <Link
                  color="text.primary"
                  component={RouterLink}
                  href={`${patients}/${patientDetails}`}
                  sx={{
                    alignItems: 'center',
                    display: 'inline-flex',
                  }}
                  underline="hover"
                >
                  <SvgIcon sx={{ mr: 1 }}>
                    <ArrowLeftIcon />
                  </SvgIcon>
                  <Typography variant="subtitle2">Back to Patient Details</Typography>
                </Link>
              </div>
              <Stack
                alignItems="flex-start"
                direction={{
                  xs: 'column',
                  md: 'row',
                }}
                justifyContent="space-between"
                spacing={4}
              >
                {patientResponse?.loading ? (
                  <Stack
                    alignItems="center"
                    direction="row"
                    spacing={2}
                  >
                    <Box sx={{ display: 'flex', width: '100%', alignItems: 'center', gap: 1 }}>
                      <Skeleton
                        animation="pulse"
                        variant="circular"
                      >
                        <Avatar sx={{ width: 70, height: 70 }} />
                      </Skeleton>
                      <Box sx={{ width: 100 }}>
                        <Typography
                          width={'100%'}
                          variant="h5"
                        >
                          <Skeleton animation="pulse" />
                        </Typography>
                        <Typography
                          width={'30%'}
                          variant="h5"
                        >
                          <Skeleton animation="pulse" />
                        </Typography>
                      </Box>
                    </Box>
                  </Stack>
                ) : (
                  <Stack
                    alignItems="center"
                    direction="row"
                    spacing={2}
                  >
                    <Avatar
                      // src={patientData?.profileImage}
                      sx={{
                        height: 64,
                        width: 64,
                      }}
                    >
                      {`${patientData?.firstName?.charAt(0).toUpperCase()}${patientData?.lastName
                        ?.charAt(0)
                        ?.toUpperCase()}`}
                    </Avatar>
                    <Stack spacing={1}>
                      <Typography variant="h5">
                        {`${patientData?.firstName} ${patientData?.lastName}  - `}
                        {location?.state?.action === 'Edit'
                          ? `${location?.state?.data?.facilityName} - Edit`
                          : 'Add'}
                        {' Facility Details'}
                      </Typography>
                    </Stack>
                  </Stack>
                )}
              </Stack>
              {/* <Container> */}
              <Stack>
                <Card sx={{ boxShadow: '0px 0px 60px rgba(0, 0, 0, 0.1) !important' }}>
                  <CardHeader
                    title={
                      location?.state?.action === 'Edit'
                        ? 'Edit Facility details'
                        : 'Add Facility details'
                    }
                  />
                  <EditFacilityStayForm
                    patientData={patientData}
                    setPatientError={setPatientError}
                    patientError={patientError}
                  />
                </Card>
              </Stack>
              {/* </Container> */}
            </Stack>
          </Stack>
        </Container>
      </Box>
    </>
  );
}

export default EditFacilityStayPage;
